export default __webpack_public_path__ + "static/media/thor.74c72fbb.png";